const mobMenu = {
  dropdowns: document.querySelectorAll(".jsNextLvl") as NodeListOf<HTMLElement>,

  init() {
    this.mobileMenuFn()
  },

  createItem(menu: HTMLElement, text: String) {
    const wrap = menu.querySelector(".jsSubmenuWrap")

    if (!wrap) {
      const div = document.createElement("div")
      div.classList.add("jsSubmenuWrap", "main-nav__head")
      div.innerHTML = `<div class="mobile-menu__link  mobile-menu__link--head newlink">   
                            <svg>
                                <use xlink:href="#angle-left-thin"></use>
                            </svg>                    
                            <span class="main-nav__header-text">${text}</span> 
                        </div>`
      menu.prepend(div)
    }
  },
  createEvent(item: HTMLElement) {
    const el = item.querySelector(".newlink")
    if (el) {
      el.addEventListener("click", (e) => {
        e.preventDefault()
        item.classList.remove("activeClass")
      })
    }
  },
  mobileMenuFn() {
    this.dropdowns.forEach((item) => {
      const subMenu = item.nextElementSibling as HTMLElement
      if (subMenu) {
        item.addEventListener("click", (e) => {
          e.preventDefault()
          const text = item.innerText
          this.createItem(subMenu, text)
          subMenu.classList.add("activeClass")
          this.createEvent(subMenu)
        })
      }
    })
  },
}

export default mobMenu
